module.exports = __webpack_public_path__ + "img/national5.df038215.png";